const LINK_SIDEBAR_STATE_KEY = 'document-link-sidebar-state';

export function clearDocumentLinkSidebarState() {
  try {
    sessionStorage.removeItem(LINK_SIDEBAR_STATE_KEY);
  } catch {
    // Ignore removal failures
  }
}

export interface DocumentLinkSidebarState {
  linkSidebar?: 'open' | null;
  linkDialog?: 'preview' | null;
  documentId?: string | null;
  category?: string | null;
  linkedArticleId?: string | null;
  originTitle?: string | null;
}

export function saveDocumentLinkSidebarState(state: DocumentLinkSidebarState) {
  try {
    const payload = {
      linkSidebar: state.linkSidebar ?? null,
      linkDialog: state.linkDialog ?? null,
      documentId: state.documentId ?? null,
      category: state.category ?? null,
      linkedArticleId: state.linkedArticleId ?? null,
      originTitle: state.originTitle ?? null,
      createdAt: Date.now(),
    };
    sessionStorage.setItem(LINK_SIDEBAR_STATE_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function consumeDocumentLinkSidebarState(): DocumentLinkSidebarState | null {
  let raw: string | null = null;
  try {
    raw = sessionStorage.getItem(LINK_SIDEBAR_STATE_KEY);
  } catch {
    raw = null;
  }
  if (!raw) {
    return null;
  }
  try {
    sessionStorage.removeItem(LINK_SIDEBAR_STATE_KEY);
  } catch {
    // ignore
  }
  try {
    return JSON.parse(raw) as DocumentLinkSidebarState;
  } catch {
    return null;
  }
}
